import React from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';

/**
 * Custom hook to fetch related search data based on itemId, navParam, and storeId.
 * The call to the data model is skipped if neither navParam nor itemId is provided.
 *
 * @param {Object} params
 * @param {string} params.itemId - The item ID for the product.
 * @param {string} params.navParam - The N-Value for the page.
 * @param {string} params.storeId - The store ID.
 * @returns {Object} - An object containing related search data, loading state, and error state.
 */
const useRelatedProductsData = ({ itemId, maxRelatedProducts, navParam, storeId: resolvedStoreId, hideRelatedProducts = false}) => {
  const storeId = useStoreId();
  const fallbackStoreId = resolvedStoreId || storeId;
  const shouldSkip = hideRelatedProducts || (!navParam && !itemId);
  
  const {
    data,
    error,
    loading,
  } = useDataModel('relatedSearchModel', {
    variables: {
      ...(itemId && { itemId }),
      ...(navParam && { navParam }),
      storeId: fallbackStoreId
    },
    skip: shouldSkip
  });

  const relatedProducts = data?.relatedSearchModel?.products || [];
  const relatedProductsToShow = relatedProducts.slice(0, maxRelatedProducts);

  return { relatedProducts: relatedProductsToShow, loading, error };
};

export { useRelatedProductsData };